import React, { useImperativeHandle } from 'react';
import { getUUID } from '../../../../utils/helpers';
import Tooltip from './Tooltip';


const SwitchButtonNR = ({ label,
    value = undefined, onClick = () => null,
    si = 'Si', no = 'No', labelInfo = ''
}) => {


    return (
        <div>
            <div className="lbl-input">
                <span> {label} </span>
            </div>

            <div className="input-switch-option">

                <button  tabIndex="-1"  onClick={e => onClick(true)} type="button" className={value === true ? 'sg-switch-active-nr' : ''}>{si}</button>
                <button  tabIndex="-1"  onClick={e => onClick(false)} type="button" className={value === false ? 'sg-switch-active-nr' : ''}>{no}</button>
                {value === undefined &&
                    <input type="radio" name={label || getUUID()} className="sg-switch-validator-nr" required />
                }
            </div>
            <div className="label-info-switch">
                {labelInfo}
             </div>

        </div>
    );
}

export default SwitchButtonNR